import React, { useEffect } from "react";
import {
  BlueBirdTheme,
  Button,
  Form, Radio, RadioGroup,
  Typography,
} from "@kitbird/core";
import { Controller, useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { FormContainer } from "./FormJobTitle.styled";

interface FormJobTitleProps {
  defaultValue: any;
  onSubmit: (value: unknown) => void;
  onClose: () => void;
}

const schema = Joi.object({
  id: Joi.number(),
  code_type: Joi.string().required().messages({ "string.empty": "Harap pilih Tipe user", "any.required": "Harap pilih Tipe user" }),
  job_title: Joi.string().required().messages({ "string.empty": "Harap pilih Jabatan", "any.required": "Harap pilih Jabatan" }),
  description: Joi.string().required().messages({ "string.empty": "Harap pilih Deskripsi", "any.required": "Harap pilih Deskripsi" }),
});

const FormJobTitle = ({
  defaultValue, onSubmit, onClose,
}: FormJobTitleProps) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      id: undefined,
      code_type: "",
      job_title: "",
      description: "",
    },
    resolver: joiResolver(schema),
  });

  useEffect(() => {
    if (defaultValue) {
      reset({
        id: defaultValue.id,
        code_type: defaultValue.code_type,
        job_title: defaultValue.job_title,
        description: defaultValue.description,
      });
    } else reset(undefined);
  }, [defaultValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit, (errors) => console.log({ errors }))}>
      <FormContainer>
        <Controller
          control={control}
          name="code_type"
          render={({
            field: {
              name, value, onChange,
            },
            fieldState: { error },
          }) => (
            <div>
              <RadioGroup
                name={name}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                title="Tipe user"
              >
                <div
                  className="radio-group"
                >
                  <Radio
                    label="HO"
                    value="O"
                  />
                  <Radio
                    label="Pool"
                    value="P"
                  />
                  <Radio
                    label="Pangkalan"
                    value="H"
                  />
                </div>
              </RadioGroup>
              <Typography
                level={7}
                color={BlueBirdTheme.colors.danger[500]}
              >{error?.message}</Typography>
            </div>
          )
          }
        />
        <Controller
          control={control}
          name="job_title"
          render={({ field, fieldState: { error } }) => (
            <Form
              {...field}
              label="Jabatan"
              autoComplete="off"
              error={error && { message: error.message || "" }}
            />
          )}
        />
        <Controller
          control={control}
          name="description"
          render={({ field, fieldState: { error } }) => (
            <Form
              {...field}
              label="Deskripsi"
              autoComplete="off"
              error={error && { message: error.message || "" }}
            />
          )}
        />
        <div className="action-container">
          <Button
            variant="text"
            type="button"
            onClick={onClose}
          >
            Batal
          </Button>
          <Button type="submit">
            Simpan
          </Button>
        </div>
      </FormContainer>
    </form>
  );
};

export default FormJobTitle;
